﻿<script setup lang="ts">
import {computed} from 'vue';
import {Icon} from '@iconify/vue';
import {useSettingsStore} from "@/stores/settings.ts";
import {storeToRefs} from "pinia";


const settingsStore = useSettingsStore();
  const { settings, mode } = storeToRefs(settingsStore);
const settingsJson = computed({
  get: () => JSON.stringify(settings.value, null, 2),
  set: (value: string) => {
    try {
      const parsed = JSON.parse(value);
      settingsStore.updateSettings(parsed);
    } catch {
      // Ignore invalid JSON while user is typing.
    }
  },
});

</script>

<template>
  <div class="glass-panel p-6 mt-6 animate-fade-in-up">
    <div class="flex justify-between items-center mb-4">
      <div class="flex items-center gap-2">
        <div class="p-1.5 bg-gray-100 rounded-lg text-gray-600">
          <Icon icon="fa6-solid:code" />
        </div>
        <label class="text-sm font-bold text-gray-700">JSON Konfiguration</label>
      </div>
      
      <div class="flex gap-2">
        <button
          id="loadJsonSettings"
          class="btn btn-primary text-xs py-1.5 px-3"
          @click="settingsStore.resetSettings"
          title="Vom Server laden"
        >
          <Icon icon="fa6-solid:download" class="mr-1.5" />Laden
        </button>
        <button
          id="saveJsonSettings"
          @click="()=>settingsStore.updateSettings(settings)"
          class="btn btn-success text-xs py-1.5 px-3"
          type="button"
          title="Speichern"
        >
          <Icon icon="fa6-solid:floppy-disk" class="mr-1.5" />Speichern
        </button>
        <button
          id="copyJsonSettings"
          class="btn btn-secondary text-xs py-1.5 px-3"
          type="button"
          title="In Zwischenablage kopieren"
        >
          <Icon icon="fa6-solid:copy" class="mr-1.5" />Kopieren
        </button>
      </div>
    </div>

    <div class="relative group">
      <textarea
        id="jsonSettingsEditor"
        class="w-full h-80 p-4 font-mono text-xs leading-relaxed bg-gray-900 text-gray-100 rounded-xl border border-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition-all resize-y shadow-inner custom-scrollbar"
        placeholder='{"BEAM_WIDTH": 20, "DEBUG_OUTPUT": true, ...}'
        spellcheck="false"
        v-model="settingsJson"
      />
      <div class="absolute bottom-3 right-3 text-[10px] text-gray-500 bg-gray-800/80 px-2 py-1 rounded backdrop-blur-sm pointer-events-none">
        JSON
      </div>
    </div>
    
    <div class="mt-3 flex items-start gap-2 text-xs text-gray-500 bg-blue-50/50 p-3 rounded-lg border border-blue-100">
      <Icon icon="fa6-solid:circle-info" class="text-blue-500 mt-0.5" />
      <p>Änderungen im Editor werden beim Speichern übernommen. Ungültiges JSON wird ignoriert.</p>
    </div>
  </div>
</template>
